/*
 * Cart bundle upsell.
 * Reads the inline JSON bundle index (rendered by cart-block-bundle-upsell.liquid).
 * For each bundle counts how many of its steps have at least one matching
 * product in the cart, then picks the ONE bundle with the fewest remaining
 * steps (bounded by that bundle's per-bundle threshold). Ties break on
 * total matching product count.
 */
(function () {
  'use strict';

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function readIndex(root) {
    var node = root.querySelector('[data-cart-bundle-index]');
    if (!node) return [];
    try {
      var data = JSON.parse(node.textContent || '[]');
      return Array.isArray(data) ? data : [];
    } catch (e) {
      return [];
    }
  }

  function render(root, entry) {
    var list = root.querySelector('[data-cart-bundle-upsell-list]');
    if (!list) return;
    list.innerHTML = '';

    if (!entry) {
      root.hidden = true;
      return;
    }
    root.hidden = false;

    var b = entry.bundle;
    var card = document.createElement('a');
    card.className = 'cart-bundle-card';
    card.href = b.url || '#';
    card.setAttribute('data-bundle-id', b.id);
    card.setAttribute('data-bundle-handle', b.handle || '');
    card.addEventListener('click', function () {
      trackClick(b.handle || String(b.id));
    });

    var mediaHtml = b.image
      ? '<div class="cart-bundle-card__media"><img src="' + b.image + '" alt="" loading="lazy"></div>'
      : '<div class="cart-bundle-card__media cart-bundle-card__media--empty"></div>';

    var badgeText;
    if (entry.stepsRemaining === 0) {
      badgeText = 'Save by buying these as a bundle';
    } else if (entry.stepsRemaining === 1) {
      badgeText = 'Just 1 product away from this bundle';
    } else {
      badgeText = entry.stepsRemaining + ' products away from this bundle';
    }

    card.innerHTML =
      mediaHtml +
      '<div class="cart-bundle-card__body">' +
        '<span class="cart-bundle-card__badge">' + escapeHtml(badgeText) + '</span>' +
        '<h4 class="cart-bundle-card__title">' + escapeHtml(b.title) + '</h4>' +
        '<p class="cart-bundle-card__price">' + escapeHtml(b.price) + '</p>' +
        '<span class="cart-bundle-card__cta">View bundle →</span>' +
      '</div>';

    list.appendChild(card);
  }

  function trackClick(bundleHandle) {
    var payload = {
      attributes: {
        bundle_upsell_source: bundleHandle,
        bundle_upsell_clicked_at: new Date().toISOString()
      }
    };
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        keepalive: true,
        body: JSON.stringify(payload)
      });
    } catch (e) { /* ignore */ }
  }

  function escapeHtml(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function evaluate(root) {
    var defaultMaxRemaining = parseInt(root.getAttribute('data-default-max-remaining') || '1', 10);
    if (isNaN(defaultMaxRemaining) || defaultMaxRemaining < 0) defaultMaxRemaining = 1;
    var defaultMaxUnrelated = parseInt(root.getAttribute('data-default-max-unrelated') || '0', 10);
    if (isNaN(defaultMaxUnrelated) || defaultMaxUnrelated < 0) defaultMaxUnrelated = 0;

    var bundles = readIndex(root);
    if (!bundles.length) {
      root.hidden = true;
      return;
    }

    fetchCart().then(function (cart) {
      if (!cart || !cart.items || !cart.items.length) {
        root.hidden = true;
        return;
      }

      var cartProductIds = {};
      cart.items.forEach(function (item) {
        cartProductIds[String(item.product_id)] = true;
      });

      var candidates = [];
      bundles.forEach(function (b) {
        if (cartProductIds[String(b.id)]) return; // bundle already in cart
        if (!Array.isArray(b.steps) || !b.steps.length) return;

        var bundleProductIds = {};
        for (var s = 0; s < b.steps.length; s++) {
          var stepIds = b.steps[s];
          if (!Array.isArray(stepIds)) continue;
          for (var t = 0; t < stepIds.length; t++) {
            bundleProductIds[String(stepIds[t])] = true;
          }
        }

        var stepsMatched = 0;
        var matchCount = 0;
        for (var i = 0; i < b.steps.length; i++) {
          var ids = b.steps[i];
          if (!Array.isArray(ids) || !ids.length) continue;
          var stepHit = false;
          for (var j = 0; j < ids.length; j++) {
            if (cartProductIds[String(ids[j])]) {
              matchCount++;
              stepHit = true;
            }
          }
          if (stepHit) stepsMatched++;
        }

        if (stepsMatched === 0) return;

        var unrelatedCount = 0;
        cart.items.forEach(function (item) {
          if (!bundleProductIds[String(item.product_id)]) unrelatedCount++;
        });

        var maxUnrelated = (typeof b.maxUnrelatedItems === 'number' && b.maxUnrelatedItems >= 0)
          ? b.maxUnrelatedItems
          : defaultMaxUnrelated;
        if (unrelatedCount > maxUnrelated) return;

        var stepsRemaining = b.steps.length - stepsMatched;
        var threshold = (typeof b.maxStepsRemaining === 'number' && b.maxStepsRemaining >= 0)
          ? b.maxStepsRemaining
          : defaultMaxRemaining;

        if (stepsRemaining > threshold) return;

        candidates.push({
          bundle: b,
          stepsMatched: stepsMatched,
          stepsRemaining: stepsRemaining,
          matchCount: matchCount
        });
      });

      if (!candidates.length) {
        render(root, null);
        return;
      }

      candidates.sort(function (a, b) {
        if (a.stepsRemaining !== b.stepsRemaining) return a.stepsRemaining - b.stepsRemaining;
        return b.matchCount - a.matchCount;
      });

      render(root, candidates[0]);
    });
  }

  function scan() {
    document.querySelectorAll('[data-cart-bundle-upsell]').forEach(evaluate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.addEventListener('theme:cart:change', scan);
  document.addEventListener('shopify:section:load', scan);
})();
